import { useState } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toast } from 'sonner';
import { UserPlus } from 'lucide-react';

export default function CreateUserTab({ onUserCreated }) {
  const [newUser, setNewUser] = useState({
    email: '',
    password: '',
    name: '',
    is_admin: false
  });

  const handleCreateUser = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/admin/users/create`, newUser);
      toast.success('User created successfully');
      setNewUser({ email: '', password: '', name: '', is_admin: false });
      if (onUserCreated) {
        onUserCreated();
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create user');
    }
  };

  return (
    <div className="bg-white border border-stone-200 rounded-sm p-8 shadow-sm max-w-2xl">
      <h2 className="font-barlow font-bold text-2xl text-slate-900 uppercase tracking-tight mb-2">
        Create New User
      </h2>
      <p className="text-stone-600 font-inter text-sm mb-6">
        Add a new user to the system
      </p>
      
      <form onSubmit={handleCreateUser} className="space-y-4">
        <div>
          <Label htmlFor="name" className="font-inter font-medium text-slate-900">Full Name</Label>
          <Input
            id="name"
            type="text"
            value={newUser.name}
            onChange={(e) => setNewUser({...newUser, name: e.target.value})}
            className="mt-1 bg-white border-stone-300 rounded-sm h-12 font-inter"
            placeholder="e.g., Moreira, Rui"
            required
          />
          <p className="text-xs text-stone-500 mt-1 font-inter">
            Use format: Last Name, First Name (e.g., &quot;Moreira, Rui&quot;)
          </p>
        </div>
        
        <div>
          <Label htmlFor="email" className="font-inter font-medium text-slate-900">Email Address</Label>
          <Input
            id="email"
            type="email"
            value={newUser.email}
            onChange={(e) => setNewUser({...newUser, email: e.target.value})}
            className="mt-1 bg-white border-stone-300 rounded-sm h-12 font-inter"
            required
          />
        </div>
        
        <div>
          <Label htmlFor="password" className="font-inter font-medium text-slate-900">Password</Label>
          <Input
            id="password"
            type="password"
            value={newUser.password}
            onChange={(e) => setNewUser({...newUser, password: e.target.value})}
            className="mt-1 bg-white border-stone-300 rounded-sm h-12 font-inter"
            required
          />
        </div>
        
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id="is_admin"
            checked={newUser.is_admin}
            onChange={(e) => setNewUser({...newUser, is_admin: e.target.checked})}
            className="w-4 h-4 text-amber-600 rounded"
          />
          <Label htmlFor="is_admin" className="font-inter text-slate-900">Make this user an admin</Label>
        </div>
        
        <Button
          type="submit"
          className="w-full bg-amber-600 text-white hover:bg-amber-700 rounded-sm uppercase tracking-wider font-bold h-12 font-barlow"
        >
          <UserPlus className="w-5 h-5 mr-2" strokeWidth={1.5} />
          Create User
        </Button>
      </form>
    </div>
  );
}
